<script setup lang="ts">
import { useRouter } from 'vue-router';
import { MMContainer, MMPopupFullScreen } from '@mm-frontend/mm-web-ui-kit';
import { useCategories } from '~/features/categories';
import MobileCatalogCategory from './MobileCatalogCategory.vue';
import { rootCategory, type CategoryMM } from '~/entities/category';

const { rootCategories, promoCategories } = useCategories();
const path = ref<CategoryMM[]>([rootCategory]);
const selectedCategory = ref<CategoryMM | null>(null);

const categories = computed(() => {
  if (!selectedCategory.value) return rootCategories.value;
  return selectedCategory.value.childrens;
})

function handleCategoryClick(category: CategoryMM) {
  if (!category.childrens?.length) return;

  selectedCategory.value = category;
  path.value = [...path.value, category];
  scrollModalToTop();
}

function handlePathClick(category: CategoryMM) {
  if (category.id === 0) {
    selectedCategory.value = null
  } else {
    selectedCategory.value = category;
  }

  const pathIndex = path.value.findIndex(c => c.id === category.id);
  path.value = path.value.slice(0, pathIndex + 1);
  scrollModalToTop();
}

const catalogModal = useTemplateRef('catalogModal');
function scrollModalToTop() {
  catalogModal.value?.$el.scrollTo({
    top: 0,
    behavior: 'instant',
  })
}
</script>

<template>
  <MMPopupFullScreen>
    <MMContainer ref="catalogModal" class="catalog-modal">
      <template v-if="!selectedCategory">
        <MobileCatalogCategory 
          v-for="category in promoCategories" 
          :key="category.id" 
          :category="category" 
          is-promo
        />
      </template>

      <template v-if="path.length > 1">
        <MobileCatalogCategory 
          v-for="category in path" 
          :key="category.id" 
          :category="category" 
          is-path
          :is-last-path-item="category.id === path[path.length - 1].id"
          @click="handlePathClick(category)" 
        />
      </template>

      <MobileCatalogCategory 
        v-for="category in categories" 
        :key="category.id" 
        :is-path="category.id === 0" 
        :category="category" 
        @click="handleCategoryClick(category)" 
      />
    </MMContainer>
  </MMPopupFullScreen>
</template>

<style scoped lang="stylus">
.catalog-modal
  margin-top 8px
  padding-top 8px
  padding-bottom 16px
  height 100%
  display flex
  flex-direction column
  overflow-y auto

  & .category
    padding-top 8px
    padding-bottom 8px
</style>